<template>
  <div class="zero2-configurator">
    <div id="container" class="zero2-configurator__container">
      <div id="sidebar" class="zero2-configurator__sidebar">
        <div class="section">
          <div class="section-title">Configurazione ZERO2</div>
          <div class="form-group">
            <label>Numero Paralumi: <span id="lampCountValue">4</span></label>
            <div class="range-group">
              <input
                type="range"
                id="lampCount"
                min="1"
                max="10"
                value="4"
                step="1"
              />
              <span class="range-value" id="lampCountDisplay">4</span>
            </div>
          </div>

          <div class="form-group">
            <label>Tipo Paralumi</label>
            <select id="lampType">
              <option value="square">Mark (5×5×5 cm)</option>
              <option value="cylinder">Bull (Ø2.5×h variabile)</option>
              <option value="voxnox">VOX/NOX (Ø12×12 cm)</option>
            </select>
          </div>

          <div class="lamp-individual-controls" id="lampIndividualControls">
            <div class="section-title">
              Dimensioni Individuali Paralumi Bull
            </div>
            <div class="form-group">
              <div id="individualSizeGrid" class="individual-size-grid">
                <!-- I controlli per ogni paralume saranno aggiunti qui dinamicamente -->
              </div>
            </div>
          </div>
        </div>

        <div class="section">
          <div class="section-title">Dimensione Stanza</div>
          <div class="form-group">
            <label>Larghezza (cm)</label>
            <input
              type="number"
              id="roomWidth"
              value="600"
              min="300"
              max="1000"
              step="10"
            />
          </div>
          <div class="form-group">
            <label>Profondita (cm)</label>
            <input
              type="number"
              id="roomDepth"
              value="800"
              min="300"
              max="1000"
              step="10"
            />
          </div>
          <div class="form-group">
            <label>Altezza (cm)</label>
            <input
              type="number"
              id="ceilingHeight"
              value="300"
              min="240"
              max="400"
              step="10"
            />
          </div>
          <div class="form-group">
            <button id="resetPositions" class="reset-button">
              Reset Posizioni Elementi
            </button>
          </div>
        </div>

        <div class="results">
          <div class="section-title">Lunghezza Cavi</div>
          <div id="cableResults">
            <!-- Risultati qui -->
          </div>
          <div class="result-item total">
            <span>TOTALE</span>
            <span id="totalCable">0 cm</span>
          </div>

          <button id="downloadPdf" class="pdf-button">
            📥 SCARICA PDF CONFIGURAZIONE
          </button>

          <div class="zava-logo">
            <img
              src="data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='144'%20height='30'%3e%3cpath%20fill='none'%20d='M0%200h144v30H0z'%20data-name='Frame'/%3e%3cpath%20fill='%232e2e2e'%20d='M6.62%2025.422h17.9V30H0v-4.285L17.392%204.506H1.312V0h22.774v3.923Z'/%3e%3cpath%20fill='%232e2e2e'%20d='M99.978%200h5.311L95.176%2030h-5.965L79.243%200h5.456l7.566%2023.754ZM56.537%200l9.971%2030h-5.46L53.627%206.174h-.145L45.768%2030h-5.31L50.719%200ZM144%2030h-5.456l-7.638-23.826h-.15L123.192%2030h-5.313l10.186-30h5.9Z'%20data-name='Vector'/%3e%3c/svg%3e"
              alt="ZAVA srl"
            />
          </div>
        </div>
      </div>

      <div id="viewport" class="zero2-configurator__viewport">
        <div class="view-container" id="view3d">
          <div class="view-label">VISTA 3D - Clicca elementi per spostare</div>
          <div class="help-text" id="help3d">
            👆 Clicca su un elemento per selezionarlo<br />
            🔴 Trascina frecce/assi per spostare<br />
            🟢 Supporti e Rosone sono indipendenti dai Paralumi<br />
            🔵 I cavi si aggiornano automaticamente
          </div>
          <div id="scene3d" class="scene-container"></div>
          <div class="mode-controls" id="modeControls3d">
            <button class="mode-btn active" data-mode="translate">
              Sposta
            </button>
          </div>
          <div id="info">
            <div id="info-title">Nessun elemento selezionato</div>
            <div id="info-coords">X: 0.0 | Y: 0.0 | Z: 0.0</div>
          </div>
        </div>

        <div class="view-container" id="viewTop">
          <div class="view-label">
            PIANTA (X-Z) - Vista dall'alto - Clicca e trascina
          </div>
          <div class="view-controls">
            <button class="view-btn" id="resetTop">Centra</button>
            <button class="view-btn" id="zoomInTop">+</button>
            <button class="view-btn" id="zoomOutTop">-</button>
          </div>
          <div id="sceneTop" class="scene-container"></div>
          <div class="axis-indicator">
            X → Larghezza | Z → Profondita (Vista dall'alto)
          </div>
        </div>

        <div class="view-container" id="viewSide">
          <div class="view-label">
            VISTA LATERALE (X-Y) - Clicca sui paralumi per regolare l'altezza
          </div>
          <div class="view-controls">
            <button class="view-btn" id="resetSide">Centra</button>
            <button class="view-btn" id="zoomInSide">+</button>
            <button class="view-btn" id="zoomOutSide">-</button>
          </div>
          <div id="sceneSide" class="scene-container"></div>
        </div>
      </div>
    </div>

    <div class="notification" id="notification">
      Elementi riposizionati in linea retta
    </div>
  </div>
</template>

<script setup>
import { nextTick, onBeforeUnmount, onMounted } from 'vue'

const scriptRegistry = new Map()

const loadScript = (src) => {
  if (scriptRegistry.has(src)) {
    return scriptRegistry.get(src)
  }

  const promise = new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${src}"]`)

    if (existing) {
      if (existing.dataset.loaded === 'true') {
        resolve()
        return
      }

      existing.addEventListener('load', () => resolve(), { once: true })
      existing.addEventListener(
        'error',
        () => reject(new Error(`Failed to load ${src}`)),
        { once: true }
      )
      return
    }

    const script = document.createElement('script')
    script.src = src
    script.async = true
    script.dataset.zero2Script = 'true'
    script.addEventListener(
      'load',
      () => {
        script.dataset.loaded = 'true'
        resolve()
      },
      { once: true }
    )
    script.addEventListener(
      'error',
      () => reject(new Error(`Failed to load ${src}`)),
      { once: true }
    )
    document.head.appendChild(script)
  })

  scriptRegistry.set(src, promise)
  return promise
}

class LampConfigurator3D {
  constructor() {
    // Parametri
    this.lampCount = 4
    this.lampType = 'square'
    this.defaultBullSize = '20'
    this.individualBullSizes = {}
    this.roomWidth = 600
    this.roomDepth = 800
    this.ceilingHeight = 300

    // Scene
    this.scenes = {}
    this.cameras = {}
    this.renderers = {}
    this.controls = {}
    this.transformControls = {}

    // Elementi
    this.rosette3d = null
    this.lamps3d = []
    this.brackets3d = []
    this.cables3d = []
    this.finalBracket3d = null

    this.lampsSide = []
    this.bracketsSide = []
    this.rosetteSide = null
    this.cablesSide = []
    this.finalBracketSide = null

    this.lampsTop = []
    this.bracketsTop = []
    this.rosetteTop = null
    this.cablesTop = []
    this.finalBracketTop = null

    // Griglie
    this.gridElementsTop = []

    // Stato
    this.selectedObject = null
    this.selectedObjectType = null
    this.selectedObjectIndex = null

    // Elementi della stanza
    this.roomElements3d = []
    this.roomElementsTop = []
    this.roomElementsSide = []

    this.currentMode = 'translate'
    this.spacing = 80

    this._cleanupFns = []
    this._animationId = null
    this._isDestroyed = false

    this.init()
  }

  _addListener(target, type, handler, options) {
    target.addEventListener(type, handler, options)
    this._cleanupFns.push(() =>
      target.removeEventListener(type, handler, options)
    )
  }

  destroy() {
    this._isDestroyed = true
    if (this._animationId) {
      cancelAnimationFrame(this._animationId)
    }
    this._cleanupFns.forEach((cleanup) => cleanup())
    this._cleanupFns = []
  }

  init() {
    this.createScenes()
    this.setupEventListeners()
    this.createRoom()
    this.createElements()
    this.updateIndividualSizeControls()
    this.createTopGrid()

    setTimeout(() => {
      this.centerView('top')
      this.centerView('side')
    }, 100)

    this.animate()
  }

  createTopGrid() {
    if (!this.scenes['top']) return

    this.removeTopGrid()

    const gridSize = Math.max(this.roomWidth, this.roomDepth) * 1.5
    const gridDivisions = Math.ceil(gridSize / 50) * 5

    const majorGrid = new THREE.GridHelper(
      gridSize,
      gridDivisions / 5,
      0x888888,
      0x888888
    )
    majorGrid.rotation.x = -Math.PI / 2
    majorGrid.position.y = 0.1
    majorGrid.userData = { type: 'grid' }
    this.scenes['top'].add(majorGrid)
    this.gridElementsTop.push(majorGrid)

    const minorGrid = new THREE.GridHelper(
      gridSize,
      gridDivisions,
      0xdddddd,
      0xdddddd
    )
    minorGrid.rotation.x = -Math.PI / 2
    minorGrid.position.y = 0.11
    minorGrid.userData = { type: 'grid' }
    this.scenes['top'].add(minorGrid)
    this.gridElementsTop.push(minorGrid)
  }

  removeTopGrid() {
    this.gridElementsTop.forEach((element) => {
      if (element && this.scenes['top']) {
        this.scenes['top'].remove(element)
      }
    })
    this.gridElementsTop = []
  }

  getLampHeight(index) {
    if (this.lampType === 'square') return 5
    if (this.lampType === 'cylinder') {
      return parseFloat(this.individualBullSizes[index] || '20')
    }
    if (this.lampType === 'voxnox') return 12
    return 5
  }

  updateLampHeight(index, height) {
    if (this.lampType === 'cylinder') {
      this.individualBullSizes[index] = parseFloat(height)
      this.updateLampGeometry(index)
    }
  }

  updateAllLampHeights() {
    if (this.lampType === 'square') {
      for (let i = 0; i < this.lampCount; i += 1) {
        this.individualBullSizes[i] = 5
      }
    } else if (this.lampType === 'cylinder') {
      for (let i = 0; i < this.lampCount; i += 1) {
        if (this.individualBullSizes[i] === undefined) {
          this.individualBullSizes[i] = 20
        }
      }
    } else if (this.lampType === 'voxnox') {
      for (let i = 0; i < this.lampCount; i += 1) {
        this.individualBullSizes[i] = 12
      }
    }

    for (let i = 0; i < this.lampCount; i += 1) {
      this.updateLampGeometry(i)
    }
  }

  updateLampGeometry(index) {
    const height = this.getLampHeight(index)

    // Vista 3D
    if (this.lamps3d[index]) {
      let geometry
      if (this.lampType === 'square') {
        geometry = new THREE.BoxGeometry(5, height, 5)
      } else if (this.lampType === 'cylinder') {
        geometry = new THREE.CylinderGeometry(1.25, 1.25, height, 12)
      } else if (this.lampType === 'voxnox') {
        geometry = new THREE.CylinderGeometry(6, 6, height, 32)
      }

      if (geometry) {
        this.lamps3d[index].geometry.dispose()
        this.lamps3d[index].geometry = geometry
        this.lamps3d[index].userData.height = height
      }
    }

    // Vista Laterale
    if (this.lampsSide[index]) {
      let geometry
      if (this.lampType === 'square') {
        geometry = new THREE.BoxGeometry(5, height, 1)
      } else if (this.lampType === 'cylinder') {
        geometry = new THREE.BoxGeometry(2.5, height, 1)
      } else if (this.lampType === 'voxnox') {
        geometry = new THREE.BoxGeometry(12, height, 1)
      }

      if (geometry) {
        this.lampsSide[index].geometry.dispose()
        this.lampsSide[index].geometry = geometry
        this.lampsSide[index].userData.height = height
      }
    }

    this.createCablesForAllViews()
    this.calculateCables()
    this.updateHeightLabels()
  }

  createScenes() {
    this.create3DView()
    this.createTopView()
    this.createSideView()
  }

  create3DView() {
    const container = document.getElementById('scene3d')
    const aspect = container.clientWidth / container.clientHeight

    this.scenes['3d'] = new THREE.Scene()
    this.scenes['3d'].background = new THREE.Color(0xffffff)

    this.cameras['3d'] = new THREE.PerspectiveCamera(45, aspect, 1, 5000)
    this.cameras['3d'].position.set(400, 300, 400)
    this.cameras['3d'].lookAt(0, 100, 0)

    this.renderers['3d'] = new THREE.WebGLRenderer({
      antialias: true,
      alpha: false,
      preserveDrawingBuffer: true,
    })
    this.renderers['3d'].setSize(container.clientWidth, container.clientHeight)
    this.renderers['3d'].domElement.style.position = 'absolute'
    container.appendChild(this.renderers['3d'].domElement)

    this.controls['3d'] = new THREE.OrbitControls(
      this.cameras['3d'],
      this.renderers['3d'].domElement
    )
    this.controls['3d'].enableDamping = true
    this.controls['3d'].screenSpacePanning = true

    this.transformControls['3d'] = new THREE.TransformControls(
      this.cameras['3d'],
      this.renderers['3d'].domElement
    )
    this.transformControls['3d'].setMode('translate')
    this.transformControls['3d'].setSpace('world')
    this.transformControls['3d'].size = 0.8
    this.scenes['3d'].add(this.transformControls['3d'])

    this.transformControls['3d'].addEventListener(
      'dragging-changed',
      (event) => {
        this.controls['3d'].enabled = !event.value
        if (event.value && this.selectedObject) {
          this.applyTransformConstraints()
        }
      }
    )

    this.transformControls['3d'].addEventListener('change', () => {
      if (this.selectedObject) {
        this.updateCorrespondingObjects()
        this.updateLampPositions()
        this.createCablesForAllViews()
        this.calculateCables()
        this.updateInfo()
        this.updateHeightLabels()
      }
    })

    const ambientLight = new THREE.AmbientLight(0xffffff, 0.6)
    this.scenes['3d'].add(ambientLight)

    const directionalLight = new THREE.DirectionalLight(0xffffff, 0.8)
    directionalLight.position.set(100, 200, 100)
    this.scenes['3d'].add(directionalLight)
  }

  createTopView() {
    const container = document.getElementById('sceneTop')
    const aspect = container.clientWidth / container.clientHeight

    this.scenes['top'] = new THREE.Scene()
    this.scenes['top'].background = new THREE.Color(0xf8f8f8)

    let cameraWidth
    let cameraHeight
    const roomAspect = this.roomWidth / this.roomDepth

    if (aspect > roomAspect) {
      cameraHeight = this.roomDepth
      cameraWidth = cameraHeight * aspect
    } else {
      cameraWidth = this.roomWidth
      cameraHeight = cameraWidth / aspect
    }

    const marginFactor = 1.2
    cameraWidth *= marginFactor
    cameraHeight *= marginFactor

    this.cameras['top'] = new THREE.OrthographicCamera(
      -cameraWidth / 2,
      cameraWidth / 2,
      cameraHeight / 2,
      -cameraHeight / 2,
      1,
      1000
    )
    this.cameras['top'].position.set(0, 500, 0)
    this.cameras['top'].lookAt(0, 0, 0)
    this.cameras['top'].up.set(0, 0, 1)
    this.cameras['top'].updateProjectionMatrix()

    this.renderers['top'] = new THREE.WebGLRenderer({
      antialias: true,
      alpha: false,
      preserveDrawingBuffer: true,
    })
    this.renderers['top'].setSize(container.clientWidth, container.clientHeight)
    this.renderers['top'].domElement.style.position = 'absolute'
    container.appendChild(this.renderers['top'].domElement)

    this.controls['top'] = new THREE.OrbitControls(
      this.cameras['top'],
      this.renderers['top'].domElement
    )
    this.controls['top'].enableRotate = false
    this.controls['top'].enablePan = true
    this.controls['top'].enableZoom = true
    this.controls['top'].screenSpacePanning = true

    this.transformControls['top'] = new THREE.TransformControls(
      this.cameras['top'],
      this.renderers['top'].domElement
    )
    this.transformControls['top'].setMode('translate')
    this.transformControls['top'].setSpace('world')
    this.transformControls['top'].size = 0.8
    this.scenes['top'].add(this.transformControls['top'])

    this.transformControls['top'].addEventListener(
      'dragging-changed',
      (event) => {
        this.controls['top'].enabled = !event.value
        if (event.value && this.selectedObject) {
          this.applyTransformConstraints()
        }
      }
    )

    this.transformControls['top'].addEventListener('change', () => {
      if (this.selectedObject) {
        this.updateCorrespondingObjects()
        this.updateLampPositions()
        this.createCablesForAllViews()
        this.calculateCables()
        this.updateInfo()
      }
    })

    const ambientLight = new THREE.AmbientLight(0xffffff, 1.0)
    this.scenes['top'].add(ambientLight)
  }

  createSideView() {
    const container = document.getElementById('sceneSide')
    const aspect = container.clientWidth / container.clientHeight

    this.scenes['side'] = new THREE.Scene()
    this.scenes['side'].background = new THREE.Color(0xf8f8f8)

    let cameraWidth
    let cameraHeight
    const roomAspect = this.roomWidth / this.ceilingHeight

    if (aspect > roomAspect) {
      cameraHeight = this.ceilingHeight
      cameraWidth = cameraHeight * aspect
    } else {
      cameraWidth = this.roomWidth
      cameraHeight = cameraWidth / aspect
    }

    const marginFactor = 1.5
    cameraWidth *= marginFactor
    cameraHeight *= marginFactor

    const systemMaxY = this.ceilingHeight
    const viewCenterY = systemMaxY * 0.4

    this.cameras['side'] = new THREE.OrthographicCamera(
      -cameraWidth / 2,
      cameraWidth / 2,
      cameraHeight / 2,
      -cameraHeight / 2,
      1,
      1000
    )
    this.cameras['side'].position.set(0, viewCenterY, 500)
    this.cameras['side'].lookAt(0, viewCenterY, 0)
    this.cameras['side'].up.set(0, 1, 0)
    this.cameras['side'].updateProjectionMatrix()

    this.renderers['side'] = new THREE.WebGLRenderer({
      antialias: true,
      alpha: false,
      preserveDrawingBuffer: true,
    })
    this.renderers['side'].setSize(
      container.clientWidth,
      container.clientHeight
    )
    this.renderers['side'].domElement.style.position = 'absolute'
    container.appendChild(this.renderers['side'].domElement)

    this.controls['side'] = new THREE.OrbitControls(
      this.cameras['side'],
      this.renderers['side'].domElement
    )
    this.controls['side'].enableRotate = false
    this.controls['side'].enablePan = true
    this.controls['side'].enableZoom = true
    this.controls['side'].screenSpacePanning = true
    this.controls['side'].minZoom = 0.1
    this.controls['side'].maxZoom = 10

    this.transformControls['side'] = new THREE.TransformControls(
      this.cameras['side'],
      this.renderers['side'].domElement
    )
    this.transformControls['side'].setMode('translate')
    this.transformControls['side'].setSpace('world')
    this.transformControls['side'].size = 0.8
    this.scenes['side'].add(this.transformControls['side'])

    this.transformControls['side'].addEventListener(
      'dragging-changed',
      (event) => {
        this.controls['side'].enabled = !event.value
        if (event.value && this.selectedObject) {
          this.applyTransformConstraints()
        }
      }
    )

    this.transformControls['side'].addEventListener('change', () => {
      if (this.selectedObject) {
        this.updateCorrespondingObjects()
        this.updateLampPositions()
        this.createCablesForAllViews()
        this.calculateCables()
        this.updateInfo()
        this.updateHeightLabels()
      }
    })

    const ambientLight = new THREE.AmbientLight(0xffffff, 1.0)
    this.scenes['side'].add(ambientLight)
  }

  createRoom() {
    this.removeRoomElements()

    // Vista 3D
    if (this.scenes['3d']) {
      const gridHelper = new THREE.GridHelper(1000, 20, 0x888888, 0xcccccc)
      gridHelper.position.y = 0
      gridHelper.userData = { type: 'room' }
      this.scenes['3d'].add(gridHelper)
      this.roomElements3d.push(gridHelper)

      const roomGeometry = new THREE.BoxGeometry(
        this.roomWidth,
        this.ceilingHeight,
        this.roomDepth
      )
      const roomEdges = new THREE.EdgesGeometry(roomGeometry)
      const roomLines = new THREE.LineSegments(
        roomEdges,
        new THREE.LineBasicMaterial({ color: 0x000000 })
      )
      roomLines.position.y = this.ceilingHeight / 2
      roomLines.userData = { type: 'room' }
      this.scenes['3d'].add(roomLines)
      this.roomElements3d.push(roomLines)

      const floorGeometry = new THREE.PlaneGeometry(
        this.roomWidth,
        this.roomDepth
      )
      const floorMaterial = new THREE.MeshBasicMaterial({
        color: 0xe0e0e0,
        side: THREE.DoubleSide,
        transparent: true,
        opacity: 0.3,
      })
      const floor = new THREE.Mesh(floorGeometry, floorMaterial)
      floor.rotation.x = Math.PI / 2
      floor.position.y = 0
      floor.userData = { type: 'room' }
      this.scenes['3d'].add(floor)
      this.roomElements3d.push(floor)
    }

    // Vista Pianta
    if (this.scenes['top']) {
      const topRectGeometry = new THREE.PlaneGeometry(
        this.roomWidth,
        this.roomDepth
      )
      const topRectMaterial = new THREE.MeshBasicMaterial({
        color: 0xf0f0f0,
        side: THREE.DoubleSide,
        transparent: true,
        opacity: 0.4,
      })
      const topRect = new THREE.Mesh(topRectGeometry, topRectMaterial)
      topRect.rotation.x = -Math.PI / 2
      topRect.position.y = 0.1
      topRect.userData = { type: 'room' }
      this.scenes['top'].add(topRect)
      this.roomElementsTop.push(topRect)

      const topBorderGeometry = new THREE.BoxGeometry(
        this.roomWidth,
        0.2,
        this.roomDepth
      )
      const topBorderEdges = new THREE.EdgesGeometry(topBorderGeometry)
      const topBorder = new THREE.LineSegments(
        topBorderEdges,
        new THREE.LineBasicMaterial({
          color: 0x888888,
          linewidth: 1,
        })
      )
      topBorder.rotation.x = -Math.PI / 2
      topBorder.position.y = 0.2
      topBorder.userData = { type: 'room' }
      this.scenes['top'].add(topBorder)
      this.roomElementsTop.push(topBorder)
    }

    // Vista Laterale
    if (this.scenes['side']) {
      const lineMaterial = new THREE.LineBasicMaterial({
        color: 0x000000,
        linewidth: 1,
      })

      // Pavimento (in basso)
      const floorPoints = [
        new THREE.Vector3(-this.roomWidth / 2, 0, 0),
        new THREE.Vector3(this.roomWidth / 2, 0, 0),
      ]
      const floorGeometry = new THREE.BufferGeometry().setFromPoints(
        floorPoints
      )
      const floorLine = new THREE.Line(floorGeometry, lineMaterial)
      floorLine.position.y = 0
      floorLine.userData = { type: 'room' }
      this.scenes['side'].add(floorLine)
      this.roomElementsSide.push(floorLine)

      // Soffitto (in alto)
      const ceilingPoints = [
        new THREE.Vector3(-this.roomWidth / 2, this.ceilingHeight, 0),
        new THREE.Vector3(this.roomWidth / 2, this.ceilingHeight, 0),
      ]
      const ceilingGeometry = new THREE.BufferGeometry().setFromPoints(
        ceilingPoints
      )
      const ceilingLine = new THREE.Line(ceilingGeometry, lineMaterial)
      ceilingLine.position.y = this.ceilingHeight
      ceilingLine.userData = { type: 'room' }
      this.scenes['side'].add(ceilingLine)
      this.roomElementsSide.push(ceilingLine)

      // Parete sinistra
      const leftWallPoints = [
        new THREE.Vector3(-this.roomWidth / 2, 0, 0),
        new THREE.Vector3(-this.roomWidth / 2, this.ceilingHeight, 0),
      ]
      const leftWallGeometry = new THREE.BufferGeometry().setFromPoints(
        leftWallPoints
      )
      const leftWallLine = new THREE.Line(leftWallGeometry, lineMaterial)
      leftWallLine.userData = { type: 'room' }
      this.scenes['side'].add(leftWallLine)
      this.roomElementsSide.push(leftWallLine)

      // Parete destra
      const rightWallPoints = [
        new THREE.Vector3(this.roomWidth / 2, 0, 0),
        new THREE.Vector3(this.roomWidth / 2, this.ceilingHeight, 0),
      ]
      const rightWallGeometry = new THREE.BufferGeometry().setFromPoints(
        rightWallPoints
      )
      const rightWallLine = new THREE.Line(rightWallGeometry, lineMaterial)
      rightWallLine.userData = { type: 'room' }
      this.scenes['side'].add(rightWallLine)
      this.roomElementsSide.push(rightWallLine)
    }

    this.updateTopGrid()
  }

  updateTopGrid() {
    this.removeTopGrid()
    this.createTopGrid()
  }

  removeRoomElements() {
    this.roomElements3d.forEach((element) => {
      if (element && this.scenes['3d']) {
        this.scenes['3d'].remove(element)
      }
    })
    this.roomElements3d = []

    this.roomElementsTop.forEach((element) => {
      if (element && this.scenes['top']) {
        this.scenes['top'].remove(element)
      }
    })
    this.roomElementsTop = []

    this.roomElementsSide.forEach((element) => {
      if (element && this.scenes['side']) {
        this.scenes['side'].remove(element)
      }
    })
    this.roomElementsSide = []
  }

  createElements(resetPositions = true) {
    this.cleanupAllElements()

    const createFinalBracket =
      this.lampCount > 0 && (this.lampType !== 'voxnox' || this.lampCount >= 2)

    this.createRosettes()

    for (let i = 0; i < this.lampCount; i += 1) {
      this.createBracket(i)
    }

    if (createFinalBracket) {
      this.createFinalBracket()
    }

    for (let i = 0; i < this.lampCount; i += 1) {
      this.createLamp(i)
    }

    if (resetPositions) {
      this.resetElementsToLine()
    }

    this.createCablesForAllViews()
    this.calculateCables()
    this.deselectObject()

    setTimeout(() => {
      this.centerView('top')
      this.centerView('side')
    }, 50)
  }

  cleanupAllElements() {
    const viewSide = document.getElementById('viewSide')
    const heightLabels = viewSide.querySelectorAll(
      '.height-label, .height-line'
    )
    heightLabels.forEach((el) => el.remove())

    Object.keys(this.scenes).forEach((view) => {
      const scene = this.scenes[view]
      if (!scene) return

      const toRemove = []
      scene.children.forEach((child) => {
        if (
          child.userData.type === 'lamp' ||
          child.userData.type === 'bracket' ||
          child.userData.type === 'rosette' ||
          child.userData.type === 'finalBracket' ||
          child.userData.type === 'cable'
        ) {
          toRemove.push(child)
        }
      })
      toRemove.forEach((obj) => scene.remove(obj))
    })

    this.lamps3d = []
    this.lampsSide = []
    this.lampsTop = []
    this.brackets3d = []
    this.bracketsSide = []
    this.bracketsTop = []
    this.cables3d = []
    this.cablesSide = []
    this.cablesTop = []
    this.rosette3d = null
    this.rosetteSide = null
    this.rosetteTop = null
    this.finalBracket3d = null
    this.finalBracketSide = null
    this.finalBracketTop = null
  }

  createRosettes() {
    const rosetteX = -this.roomWidth * 0.3
    const rosetteY = this.ceilingHeight - 1.5

    // Vista 3D
    const rosetteGeometry = new THREE.BoxGeometry(15, 3, 5)
    const rosetteMaterial = new THREE.MeshBasicMaterial({ color: 0x000000 })
    this.rosette3d = new THREE.Mesh(rosetteGeometry, rosetteMaterial)
    this.rosette3d.position.set(rosetteX, rosetteY, 0)
    this.rosette3d.userData = { type: 'rosette', constraint: 'horizontal' }
    this.scenes['3d'].add(this.rosette3d)

    // Vista Pianta
    const topRosetteGeometry = new THREE.CircleGeometry(8, 32)
    const topRosetteMaterial = new THREE.MeshBasicMaterial({
      color: 0x333333,
      side: THREE.DoubleSide,
    })
    this.rosetteTop = new THREE.Mesh(topRosetteGeometry, topRosetteMaterial)
    this.rosetteTop.rotation.x = -Math.PI / 2
    this.rosetteTop.position.set(rosetteX, 0.3, 0)
    this.rosetteTop.userData = { type: 'rosette', constraint: 'horizontal' }
    this.scenes['top'].add(this.rosetteTop)

    // Vista Laterale
    const sideRosetteGeometry = new THREE.BoxGeometry(16, 3, 1)
    const sideRosetteMaterial = new THREE.MeshBasicMaterial({ color: 0x222222 })
    this.rosetteSide = new THREE.Mesh(sideRosetteGeometry, sideRosetteMaterial)
    this.rosetteSide.position.set(rosetteX, rosetteY, 0)
    this.rosetteSide.userData = { type: 'rosette', constraint: 'horizontal' }
    this.scenes['side'].add(this.rosetteSide)
  }

  createLamp(index) {
    let prevBracketIndex
    let nextBracketIndex

    if (index === 0) {
      prevBracketIndex = 0
      nextBracketIndex = 1
    } else {
      prevBracketIndex = index
      nextBracketIndex = index + 1
    }

    if (nextBracketIndex >= this.lampCount && !this.finalBracket3d) {
      console.warn(
        `Paralume ${index + 1} non creato: manca supporto successivo`
      )
      return
    }

    let prevBracketPos
    let nextBracketPos

    if (prevBracketIndex < this.lampCount) {
      const prevBracket = this.brackets3d[prevBracketIndex]
      prevBracketPos = prevBracket
        ? new THREE.Vector3(
            prevBracket.position.x,
            prevBracket.position.y + 1.5,
            prevBracket.position.z
          )
        : new THREE.Vector3(0, this.ceilingHeight - 1.5, 0)
    } else {
      prevBracketPos = this.finalBracket3d
        ? new THREE.Vector3(
            this.finalBracket3d.position.x,
            this.finalBracket3d.position.y + 1.5,
            this.finalBracket3d.position.z
          )
        : new THREE.Vector3(0, this.ceilingHeight - 1.5, 0)
    }

    if (nextBracketIndex < this.lampCount) {
      const nextBracket = this.brackets3d[nextBracketIndex]
      nextBracketPos = nextBracket
        ? new THREE.Vector3(
            nextBracket.position.x,
            nextBracket.position.y + 1.5,
            nextBracket.position.z
          )
        : new THREE.Vector3(0, this.ceilingHeight - 1.5, 0)
    } else {
      nextBracketPos = this.finalBracket3d
        ? new THREE.Vector3(
            this.finalBracket3d.position.x,
            this.finalBracket3d.position.y + 1.5,
            this.finalBracket3d.position.z
          )
        : new THREE.Vector3(0, this.ceilingHeight - 1.5, 0)
    }

    const x = (prevBracketPos.x + nextBracketPos.x) / 2
    const z = (prevBracketPos.z + nextBracketPos.z) / 2

    const initialHeight = this.ceilingHeight / 2
    const height = this.getLampHeight(index)

    // Vista 3D
    let lampGeometry3d
    let lampMaterial3d

    if (this.lampType === 'square') {
      lampGeometry3d = new THREE.BoxGeometry(5, height, 5)
      lampMaterial3d = new THREE.MeshBasicMaterial({
        color: 0x666666,
        transparent: true,
        opacity: 0.8,
      })
    } else if (this.lampType === 'cylinder') {
      lampGeometry3d = new THREE.CylinderGeometry(1.25, 1.25, height, 12)
      lampMaterial3d = new THREE.MeshBasicMaterial({
        color: 0x666666,
        transparent: true,
        opacity: 0.8,
      })
    } else if (this.lampType === 'voxnox') {
      lampGeometry3d = new THREE.CylinderGeometry(6, 6, height, 32)
      lampMaterial3d = new THREE.MeshBasicMaterial({
        color: 0x444444,
        transparent: true,
        opacity: 0.9,
      })
    }

    const lamp3d = new THREE.Mesh(lampGeometry3d, lampMaterial3d)
    lamp3d.position.set(x, initialHeight, z)
    lamp3d.userData = {
      type: 'lamp',
      index: index,
      constraint: 'vertical-only',
      initialPosition: { x, y: initialHeight, z },
      height: height,
      bracketIndices: [prevBracketIndex, nextBracketIndex],
    }
    this.scenes['3d'].add(lamp3d)
    this.lamps3d.push(lamp3d)

    // Vista Pianta
    let lampGeometryTop
    if (this.lampType === 'square') {
      lampGeometryTop = new THREE.PlaneGeometry(5, 5)
    } else if (this.lampType === 'cylinder') {
      lampGeometryTop = new THREE.CircleGeometry(1.25, 24)
    } else if (this.lampType === 'voxnox') {
      lampGeometryTop = new THREE.CircleGeometry(6, 32)
    }
    const lampMaterialTop = new THREE.MeshBasicMaterial({
      color: 0x999999,
      side: THREE.DoubleSide,
    })
    const lampTop = new THREE.Mesh(lampGeometryTop, lampMaterialTop)
    lampTop.rotation.x = -Math.PI / 2
    lampTop.position.set(x, 0.2, z)
    lampTop.userData = {
      type: 'lamp',
      index: index,
      constraint: 'vertical-only',
      initialPosition: { x, y: 0, z },
    }
    this.scenes['top'].add(lampTop)
    this.lampsTop.push(lampTop)

    // Vista Laterale
    let lampGeometrySide
    if (this.lampType === 'square') {
      lampGeometrySide = new THREE.BoxGeometry(5, height, 1)
    } else if (this.lampType === 'cylinder') {
      lampGeometrySide = new THREE.BoxGeometry(2.5, height, 1)
    } else if (this.lampType === 'voxnox') {
      lampGeometrySide = new THREE.BoxGeometry(12, height, 1)
    }

    const lampMaterialSide = new THREE.MeshBasicMaterial({
      color: 0x888888,
    })

    const lampSide = new THREE.Mesh(lampGeometrySide, lampMaterialSide)
    lampSide.position.set(x, initialHeight, 0)
    lampSide.userData = {
      type: 'lamp',
      index: index,
      constraint: 'vertical-only',
      initialPosition: { x, y: initialHeight, z: 0 },
      height: height,
    }
    this.scenes['side'].add(lampSide)
    this.lampsSide.push(lampSide)

    if (index < this.lampCount) {
      const labelId = `height-label-${index}`
      const lineId = `height-line-${index}`

      const lineDiv = document.createElement('div')
      lineDiv.id = lineId
      lineDiv.className = 'height-line'
      lineDiv.style.width = '1px'
      lineDiv.style.left = '0px'
      lineDiv.style.top = '0px'
      lineDiv.style.height = '0px'
      document.getElementById('viewSide').appendChild(lineDiv)

      const labelDiv = document.createElement('div')
      labelDiv.id = labelId
      labelDiv.className = 'height-label'
      labelDiv.textContent = `${initialHeight - height / 2} cm`
      document.getElementById('viewSide').appendChild(labelDiv)

      lampSide.userData.heightLabel = { div: labelDiv, line: lineDiv }
    }
  }

  updateLampPositions() {
    for (let i = 0; i < this.lampCount; i += 1) {
      const lamp = this.lamps3d[i]
      if (!lamp) continue

      let prevBracketIndex
      let nextBracketIndex

      if (i === 0) {
        prevBracketIndex = 0
        nextBracketIndex = 1
      } else {
        prevBracketIndex = i
        nextBracketIndex = i + 1
      }

      let prevBracketPos
      let nextBracketPos

      if (prevBracketIndex < this.lampCount) {
        const prevBracket = this.brackets3d[prevBracketIndex]
        prevBracketPos = prevBracket
          ? new THREE.Vector3(
              prevBracket.position.x,
              prevBracket.position.y + 1.5,
              prevBracket.position.z
            )
          : new THREE.Vector3(0, this.ceilingHeight - 1.5, 0)
      } else {
        prevBracketPos = this.finalBracket3d
          ? new THREE.Vector3(
              this.finalBracket3d.position.x,
              this.finalBracket3d.position.y + 1.5,
              this.finalBracket3d.position.z
            )
          : new THREE.Vector3(0, this.ceilingHeight - 1.5, 0)
      }

      if (nextBracketIndex < this.lampCount) {
        const nextBracket = this.brackets3d[nextBracketIndex]
        nextBracketPos = nextBracket
          ? new THREE.Vector3(
              nextBracket.position.x,
              nextBracket.position.y + 1.5,
              nextBracket.position.z
            )
          : new THREE.Vector3(0, this.ceilingHeight - 1.5, 0)
      } else {
        nextBracketPos = this.finalBracket3d
          ? new THREE.Vector3(
              this.finalBracket3d.position.x,
              this.finalBracket3d.position.y + 1.5,
              this.finalBracket3d.position.z
            )
          : new THREE.Vector3(0, this.ceilingHeight - 1.5, 0)
      }

      const x = (prevBracketPos.x + nextBracketPos.x) / 2
      const z = (prevBracketPos.z + nextBracketPos.z) / 2

      lamp.position.set(x, lamp.position.y, z)

      if (this.lampsSide[i]) {
        this.lampsSide[i].position.set(x, lamp.position.y, 0)
      }
      if (this.lampsTop[i]) {
        this.lampsTop[i].position.set(x, 0.2, z)
      }
    }
  }

  createBracket(index) {
    if (this.lampType === 'voxnox' && index >= this.lampCount) return

    const bracketY = this.ceilingHeight - 1.5
    const x = 0
    const z = 0

    // Vista 3D
    const bracketGeometry3d = new THREE.CylinderGeometry(1.5, 1.5, 3, 12)
    const bracketMaterial3d = new THREE.MeshBasicMaterial({ color: 0x333333 })
    const bracket3d = new THREE.Mesh(bracketGeometry3d, bracketMaterial3d)
    bracket3d.position.set(x, bracketY, z)
    bracket3d.userData = {
      type: 'bracket',
      index: index,
      constraint: 'horizontal',
      initialPosition: { x, y: bracketY, z },
    }
    this.scenes['3d'].add(bracket3d)
    this.brackets3d.push(bracket3d)

    // Vista Pianta
    const bracketGeometryTop = new THREE.CircleGeometry(1.5, 24)
    const bracketMaterialTop = new THREE.MeshBasicMaterial({
      color: 0x666666,
      side: THREE.DoubleSide,
    })
    const bracketTop = new THREE.Mesh(bracketGeometryTop, bracketMaterialTop)
    bracketTop.rotation.x = -Math.PI / 2
    bracketTop.position.set(x, 0.2, z)
    bracketTop.userData = {
      type: 'bracket',
      index: index,
      constraint: 'horizontal',
      initialPosition: { x, y: 0, z },
    }
    this.scenes['top'].add(bracketTop)
    this.bracketsTop.push(bracketTop)

    // Vista Laterale
    const bracketGeometrySide = new THREE.BoxGeometry(3, 3, 1)
    const bracketMaterialSide = new THREE.MeshBasicMaterial({ color: 0x555555 })
    const bracketSide = new THREE.Mesh(bracketGeometrySide, bracketMaterialSide)
    bracketSide.position.set(x, bracketY, 0)
    bracketSide.userData = {
      type: 'bracket',
      index: index,
      constraint: 'horizontal',
      initialPosition: { x, y: bracketY, z: 0 },
    }
    this.scenes['side'].add(bracketSide)
    this.bracketsSide.push(bracketSide)
  }

  createFinalBracket() {
    if (this.lampType === 'voxnox' && this.lampCount < 2) return

    const bracketY = this.ceilingHeight - 1.5
    const x = 0
    const z = 0

    // Vista 3D
    const bracketGeometry3d = new THREE.CylinderGeometry(1.5, 1.5, 3, 12)
    const bracketMaterial3d = new THREE.MeshBasicMaterial({ color: 0x333333 })
    this.finalBracket3d = new THREE.Mesh(bracketGeometry3d, bracketMaterial3d)
    this.finalBracket3d.position.set(x, bracketY, z)
    this.finalBracket3d.userData = {
      type: 'finalBracket',
      constraint: 'horizontal',
      initialPosition: { x, y: bracketY, z },
    }
    this.scenes['3d'].add(this.finalBracket3d)

    // Vista Pianta
    const bracketGeometryTop = new THREE.CircleGeometry(1.5, 24)
    const bracketMaterialTop = new THREE.MeshBasicMaterial({
      color: 0x666666,
      side: THREE.DoubleSide,
    })
    this.finalBracketTop = new THREE.Mesh(
      bracketGeometryTop,
      bracketMaterialTop
    )
    this.finalBracketTop.rotation.x = -Math.PI / 2
    this.finalBracketTop.position.set(x, 0.2, z)
    this.finalBracketTop.userData = {
      type: 'finalBracket',
      constraint: 'horizontal',
      initialPosition: { x, y: 0, z },
    }
    this.scenes['top'].add(this.finalBracketTop)

    // Vista Laterale
    const bracketGeometrySide = new THREE.BoxGeometry(3, 3, 1)
    const bracketMaterialSide = new THREE.MeshBasicMaterial({ color: 0x555555 })
    this.finalBracketSide = new THREE.Mesh(
      bracketGeometrySide,
      bracketMaterialSide
    )
    this.finalBracketSide.position.set(x, bracketY, 0)
    this.finalBracketSide.userData = {
      type: 'finalBracket',
      constraint: 'horizontal',
      initialPosition: { x, y: bracketY, z: 0 },
    }
    this.scenes['side'].add(this.finalBracketSide)
  }

  resetElementsToLine() {
    const maxSpacing = 80
    const minSpacing = 40
    const availableWidth = this.roomWidth * 0.8

    let neededSpacing = availableWidth / (this.lampCount + 1)
    this.spacing = Math.max(minSpacing, Math.min(maxSpacing, neededSpacing))

    const totalLength = this.lampCount * this.spacing
    const startX = -totalLength / 2

    const rosetteX = startX - this.spacing
    const rosetteY = this.ceilingHeight - 1.5
    const bracketY = this.ceilingHeight - 1.5

    // Posiziona rosette
    if (this.rosette3d) {
      this.rosette3d.position.set(rosetteX, rosetteY, 0)
      this.rosette3d.userData.initialPosition = {
        x: rosetteX,
        y: rosetteY,
        z: 0,
      }
    }
    if (this.rosetteTop) {
      this.rosetteTop.position.set(rosetteX, 0.3, 0)
      this.rosetteTop.userData.initialPosition = { x: rosetteX, y: 0, z: 0 }
    }
    if (this.rosetteSide) {
      this.rosetteSide.position.set(rosetteX, rosetteY, 0)
      this.rosetteSide.userData.initialPosition = {
        x: rosetteX,
        y: rosetteY,
        z: 0,
      }
    }

    // Posiziona supporti
    for (let i = 0; i < this.lampCount; i += 1) {
      const bracketX = startX + i * this.spacing
      const z = 0

      if (this.brackets3d[i]) {
        this.brackets3d[i].position.set(bracketX, bracketY, z)
        this.brackets3d[i].userData.initialPosition = {
          x: bracketX,
          y: bracketY,
          z,
        }
      }
      if (this.bracketsTop[i]) {
        this.bracketsTop[i].position.set(bracketX, 0.2, z)
        this.bracketsTop[i].userData.initialPosition = { x: bracketX, y: 0, z }
      }
      if (this.bracketsSide[i]) {
        this.bracketsSide[i].position.set(bracketX, bracketY, 0)
        this.bracketsSide[i].userData.initialPosition = {
          x: bracketX,
          y: bracketY,
          z: 0,
        }
      }
    }

    // Posiziona supporto finale se necessario
    if (this.finalBracket3d) {
      const finalX = startX + this.lampCount * this.spacing

      this.finalBracket3d.position.set(finalX, bracketY, 0)
      this.finalBracket3d.userData.initialPosition = {
        x: finalX,
        y: bracketY,
        z: 0,
      }

      this.finalBracketTop.position.set(finalX, 0.2, 0)
      this.finalBracketTop.userData.initialPosition = { x: finalX, y: 0, z: 0 }

      this.finalBracketSide.position.set(finalX, bracketY, 0)
      this.finalBracketSide.userData.initialPosition = {
        x: finalX,
        y: bracketY,
        z: 0,
      }
    }

    this.updateLampPositions()

    this.showNotification('Elementi riposizionati in linea retta')
    this.updateHeightLabels()

    if (this.spacing < minSpacing) {
      const suggestedWidth =
        Math.ceil(((this.lampCount + 1) * maxSpacing) / 0.8 / 10) * 10
      this.showNotification(
        `Consiglio: aumenta la larghezza stanza a ${suggestedWidth} cm per migliore disposizione`
      )
    }
  }

  updateHeightLabels() {
    const container = document.getElementById('sceneSide')
    const rect = container.getBoundingClientRect()

    this.lampsSide.forEach((lamp, index) => {
      if (!lamp.userData.heightLabel || index >= this.lampCount) return

      const label = lamp.userData.heightLabel.div
      const line = lamp.userData.heightLabel.line

      const height = this.getLampHeight(index)
      const baseHeight = lamp.position.y - height / 2
      const heightFromFloor = Math.max(0, baseHeight)

      const floorWorldPosition = new THREE.Vector3(lamp.position.x, 0, 0)
      const floorScreenPosition = floorWorldPosition
        .clone()
        .project(this.cameras['side'])

      const lampWorldPosition = new THREE.Vector3(
        lamp.position.x,
        lamp.position.y - height / 2,
        0
      )
      const lampScreenPosition = lampWorldPosition
        .clone()
        .project(this.cameras['side'])

      const x = (lampScreenPosition.x * 0.5 + 0.5) * rect.width

      const yLampBottom = (-lampScreenPosition.y * 0.5 + 0.5) * rect.height
      const yFloor = (-floorScreenPosition.y * 0.5 + 0.5) * rect.height

      line.style.left = `${x + 20}px`
      line.style.top = `${yFloor}px`
      line.style.height = `${Math.max(0, yLampBottom - yFloor)}px`

      label.style.left = `${x + 25}px`
      label.style.top = `${yLampBottom - 15}px`
      label.textContent = `${heightFromFloor.toFixed(1)} cm`

      const isVisible = baseHeight > 10 && baseHeight < this.ceilingHeight - 10
      label.style.display = isVisible ? 'block' : 'none'
      line.style.display = isVisible ? 'block' : 'none'
    })
  }

  showNotification(message) {
    const notification = document.getElementById('notification')
    notification.textContent = message
    notification.style.display = 'block'

    setTimeout(() => {
      notification.style.display = 'none'
    }, 3000)
  }

  createCablesForAllViews() {
    this.createCablesForView('3d')
    this.createCablesForView('top')
    this.createCablesForView('side')
  }

  createCablesForView(viewName) {
    if (viewName === '3d') {
      this.cables3d.forEach((cable) => this.scenes['3d'].remove(cable))
      this.cables3d = []
    } else if (viewName === 'top') {
      this.cablesTop.forEach((cable) => this.scenes['top'].remove(cable))
      this.cablesTop = []
    } else if (viewName === 'side') {
      this.cablesSide.forEach((cable) => this.scenes['side'].remove(cable))
      this.cablesSide = []
    }

    if (this.lampCount === 0) return

    let cableMaterial
    if (viewName === 'top') {
      cableMaterial = new THREE.LineBasicMaterial({
        color: 0xff0000,
        linewidth: 8,
        transparent: false,
        opacity: 1.0,
      })
    } else if (viewName === '3d') {
      cableMaterial = new THREE.LineBasicMaterial({
        color: 0xff0000,
        linewidth: 3,
        transparent: true,
        opacity: 0.9,
      })
    } else if (viewName === 'side') {
      cableMaterial = new THREE.LineBasicMaterial({
        color: 0xff0000,
        linewidth: 3,
        transparent: true,
        opacity: 0.9,
      })
    }

    let startPoint
    if (viewName === '3d') {
      startPoint = new THREE.Vector3(
        this.rosette3d.position.x,
        this.rosette3d.position.y - 1.5,
        this.rosette3d.position.z
      )
    } else if (viewName === 'top') {
      startPoint = new THREE.Vector3(
        this.rosetteTop.position.x,
        0.3,
        this.rosetteTop.position.z
      )
    } else if (viewName === 'side') {
      startPoint = new THREE.Vector3(
        this.rosetteSide.position.x,
        this.rosetteSide.position.y - 1.5,
        0
      )
    }

    let currentPoint = startPoint.clone()

    // Cavo dal rosette al primo supporto
    if (this.brackets3d[0]) {
      let toBracketPoint
      if (viewName === '3d') {
        const bracket = this.brackets3d[0]
        toBracketPoint = new THREE.Vector3(
          bracket.position.x,
          bracket.position.y + 1.5,
          bracket.position.z
        )
      } else if (viewName === 'top') {
        const bracket = this.bracketsTop[0]
        toBracketPoint = new THREE.Vector3(
          bracket.position.x,
          0.2,
          bracket.position.z
        )
      } else if (viewName === 'side') {
        const bracket = this.bracketsSide[0]
        toBracketPoint = new THREE.Vector3(
          bracket.position.x,
          bracket.position.y,
          0
        )
      }

      const toBracketPoints = [currentPoint.clone(), toBracketPoint.clone()]
      const toBracketGeometry = new THREE.BufferGeometry().setFromPoints(
        toBracketPoints
      )
      const toBracketCable = new THREE.Line(toBracketGeometry, cableMaterial)
      toBracketCable.userData = { type: 'cable' }
      this.scenes[viewName].add(toBracketCable)

      if (viewName === '3d') this.cables3d.push(toBracketCable)
      else if (viewName === 'top') this.cablesTop.push(toBracketCable)
      else if (viewName === 'side') this.cablesSide.push(toBracketCable)

      currentPoint = toBracketPoint.clone()
    }

    for (let i = 0; i < this.lampCount; i += 1) {
      let lamp
      let toLampPoint
      const height = this.getLampHeight(i)

      if (viewName === '3d') {
        lamp = this.lamps3d[i]
        if (!lamp) continue

        toLampPoint = new THREE.Vector3(
          lamp.position.x,
          lamp.position.y + height / 2,
          lamp.position.z
        )
      } else if (viewName === 'top') {
        lamp = this.lampsTop[i]
        if (!lamp) continue

        toLampPoint = new THREE.Vector3(lamp.position.x, 0.2, lamp.position.z)
      } else if (viewName === 'side') {
        lamp = this.lampsSide[i]
        if (!lamp) continue

        toLampPoint = new THREE.Vector3(lamp.position.x, lamp.position.y, 0)
      }

      // Cavo dal supporto al paralume
      const toLampPoints = [currentPoint.clone(), toLampPoint.clone()]
      const toLampGeometry = new THREE.BufferGeometry().setFromPoints(
        toLampPoints
      )
      const toLampCable = new THREE.Line(toLampGeometry, cableMaterial)
      toLampCable.userData = { type: 'cable' }
      this.scenes[viewName].add(toLampCable)

      if (viewName === '3d') this.cables3d.push(toLampCable)
      else if (viewName === 'top') this.cablesTop.push(toLampCable)
      else if (viewName === 'side') this.cablesSide.push(toLampCable)

      currentPoint = toLampPoint.clone()

      // Ora dal paralume al prossimo supporto
      let nextBracketIndex
      if (i === 0) {
        nextBracketIndex = 1
      } else {
        nextBracketIndex = i + 1
      }

      let nextBracketPoint

      if (nextBracketIndex < this.lampCount) {
        if (viewName === '3d') {
          const nextBracket = this.brackets3d[nextBracketIndex]
          if (!nextBracket) continue
          nextBracketPoint = new THREE.Vector3(
            nextBracket.position.x,
            nextBracket.position.y + 1.5,
            nextBracket.position.z
          )
        } else if (viewName === 'top') {
          const nextBracket = this.bracketsTop[nextBracketIndex]
          if (!nextBracket) continue
          nextBracketPoint = new THREE.Vector3(
            nextBracket.position.x,
            0.2,
            nextBracket.position.z
          )
        } else if (viewName === 'side') {
          const nextBracket = this.bracketsSide[nextBracketIndex]
          if (!nextBracket) continue
          nextBracketPoint = new THREE.Vector3(
            nextBracket.position.x,
            nextBracket.position.y,
            0
          )
        }
      } else if (this.finalBracket3d) {
        if (viewName === '3d') {
          nextBracketPoint = new THREE.Vector3(
            this.finalBracket3d.position.x,
            this.finalBracket3d.position.y + 1.5,
            this.finalBracket3d.position.z
          )
        } else if (viewName === 'top') {
          nextBracketPoint = new THREE.Vector3(
            this.finalBracketTop.position.x,
            0.2,
            this.finalBracketTop.position.z
          )
        } else if (viewName === 'side') {
          nextBracketPoint = new THREE.Vector3(
            this.finalBracketSide.position.x,
            this.finalBracketSide.position.y,
            0
          )
        }
      } else {
        continue
      }

      // Cavo dal paralume al prossimo supporto
      const toNextBracketPoints = [
        currentPoint.clone(),
        nextBracketPoint.clone(),
      ]
      const toNextBracketGeometry = new THREE.BufferGeometry().setFromPoints(
        toNextBracketPoints
      )
      const toNextBracketCable = new THREE.Line(
        toNextBracketGeometry,
        cableMaterial
      )
      toNextBracketCable.userData = { type: 'cable' }
      this.scenes[viewName].add(toNextBracketCable)

      if (viewName === '3d') this.cables3d.push(toNextBracketCable)
      else if (viewName === 'top') this.cablesTop.push(toNextBracketCable)
      else if (viewName === 'side') this.cablesSide.push(toNextBracketCable)

      currentPoint = nextBracketPoint.clone()
    }
  }

  setupEventListeners() {
    const lampCountSlider = document.getElementById('lampCount')
    this._addListener(lampCountSlider, 'input', (e) => {
      this.lampCount = parseInt(e.target.value, 10)
      document.getElementById('lampCountValue').textContent = this.lampCount
      document.getElementById('lampCountDisplay').textContent = this.lampCount

      if (this.lampType === 'cylinder') {
        for (let i = 0; i < this.lampCount; i += 1) {
          if (this.individualBullSizes[i] === undefined) {
            this.individualBullSizes[i] = 20
          }
        }
      }

      this.createElements(true)
      this.updateIndividualSizeControls()

      setTimeout(() => {
        this.centerView('top')
        this.centerView('side')
      }, 50)
    })

    this._addListener(document.getElementById('lampType'), 'change', (e) => {
      this.lampType = e.target.value
      const lampCountSliderElement = document.getElementById('lampCount')

      if (this.lampType === 'cylinder') {
        lampCountSliderElement.max = 10
        if (this.lampCount > 10) {
          this.lampCount = 10
          lampCountSliderElement.value = 10
          document.getElementById('lampCountValue').textContent = '10'
          document.getElementById('lampCountDisplay').textContent = '10'
        }

        for (let i = 0; i < this.lampCount; i += 1) {
          if (this.individualBullSizes[i] === undefined) {
            this.individualBullSizes[i] = 20
          }
        }

        this.updateAllLampHeights()
      } else if (this.lampType === 'voxnox') {
        lampCountSliderElement.max = 3
        if (this.lampCount > 3) {
          this.lampCount = 3
          lampCountSliderElement.value = 3
          document.getElementById('lampCountValue').textContent = '3'
          document.getElementById('lampCountDisplay').textContent = '3'
        }

        this.updateAllLampHeights()
      } else {
        lampCountSliderElement.max = 10
        this.updateAllLampHeights()
      }

      this.createElements(true)
      this.updateIndividualSizeControls()

      setTimeout(() => {
        this.centerView('top')
        this.centerView('side')
      }, 50)
    })

    let roomWidthTimeout
    let roomDepthTimeout
    let ceilingHeightTimeout

    this._addListener(document.getElementById('roomWidth'), 'input', (e) => {
      clearTimeout(roomWidthTimeout)
      roomWidthTimeout = setTimeout(() => {
        this.roomWidth = parseInt(e.target.value, 10)
        this.removeRoomElements()
        this.createRoom()
        this.updateOrthographicCameras()
        this.createElements(true)

        setTimeout(() => {
          this.centerView('top')
          this.centerView('side')
        }, 50)
      }, 500)
    })

    this._addListener(document.getElementById('roomDepth'), 'input', (e) => {
      clearTimeout(roomDepthTimeout)
      roomDepthTimeout = setTimeout(() => {
        this.roomDepth = parseInt(e.target.value, 10)
        this.removeRoomElements()
        this.createRoom()
        this.updateOrthographicCameras()
        this.createElements(true)

        setTimeout(() => {
          this.centerView('top')
          this.centerView('side')
        }, 50)
      }, 500)
    })

    this._addListener(
      document.getElementById('ceilingHeight'),
      'input',
      (e) => {
        clearTimeout(ceilingHeightTimeout)
        ceilingHeightTimeout = setTimeout(() => {
          this.ceilingHeight = parseInt(e.target.value, 10)
          this.removeRoomElements()
          this.createRoom()
          this.updateOrthographicCameras()
          this.createElements(true)

          setTimeout(() => {
            this.centerView('top')
            this.centerView('side')
          }, 50)
        }, 500)
      }
    )

    this._addListener(
      document.getElementById('resetPositions'),
      'click',
      () => {
        this.resetElementsToLine()
        this.createCablesForAllViews()
        this.calculateCables()
        this.showNotification('Elementi riposizionati in linea retta')

        setTimeout(() => {
          this.centerView('top')
          this.centerView('side')
        }, 50)
      }
    )
    ;['top', 'side'].forEach((viewName) => {
      const title = viewName.charAt(0).toUpperCase() + viewName.slice(1)
      this._addListener(
        document.getElementById(`reset${title}`),
        'click',
        () => {
          this.centerView(viewName)
        }
      )

      this._addListener(
        document.getElementById(`zoomIn${title}`),
        'click',
        () => {
          this.zoomView(viewName, 1.2)
        }
      )

      this._addListener(
        document.getElementById(`zoomOut${title}`),
        'click',
        () => {
          this.zoomView(viewName, 1 / 1.2)
        }
      )
    })

    this._addListener(this.renderers['3d'].domElement, 'click', (event) => {
      this.handleObjectClick('3d', event)
    })

    this._addListener(this.renderers['top'].domElement, 'click', (event) => {
      this.handleObjectClick('top', event)
    })

    this._addListener(this.renderers['side'].domElement, 'click', (event) => {
      this.handleObjectClick('side', event)
    })

    this._addListener(document, 'click', (event) => {
      const isRendererClick = Array.from(
        document.querySelectorAll('.scene-container canvas')
      ).some((canvas) => {
        const rect = canvas.getBoundingClientRect()
        return (
          event.clientX >= rect.left &&
          event.clientX <= rect.right &&
          event.clientY >= rect.top &&
          event.clientY <= rect.bottom
        )
      })

      const isModeControlClick = event.target.closest('.mode-controls')

      if (!isRendererClick && !isModeControlClick && this.selectedObject) {
        this.deselectObject()
      }
    })

    const modeButtons = document.querySelectorAll('#modeControls3d .mode-btn')
    modeButtons.forEach((button) => {
      this._addListener(button, 'click', (event) => {
        const mode = event.target.dataset.mode
        this.setTransformMode(mode)

        modeButtons.forEach((btn) => btn.classList.remove('active'))
        event.target.classList.add('active')
      })
    })

    this._addListener(document.getElementById('downloadPdf'), 'click', () => {
      this.downloadPdf()
    })

    this._addListener(window, 'resize', () => {
      Object.keys(this.renderers).forEach((name) => {
        const renderer = this.renderers[name]
        const camera = this.cameras[name]
        const container = document.getElementById(
          `scene${name.charAt(0).toUpperCase() + name.slice(1)}`
        )

        if (renderer && container) {
          const width = container.clientWidth
          const height = container.clientHeight

          renderer.setSize(width, height)

          if (camera && camera.isOrthographicCamera) {
            const aspect = width / height

            if (name === 'top') {
              const roomAspect = this.roomWidth / this.roomDepth
              let cameraWidth
              let cameraHeight

              if (aspect > roomAspect) {
                cameraHeight = this.roomDepth
                cameraWidth = cameraHeight * aspect
              } else {
                cameraWidth = this.roomWidth
                cameraHeight = cameraWidth / aspect
              }

              const marginFactor = 1.2
              cameraWidth *= marginFactor
              cameraHeight *= marginFactor

              camera.left = -cameraWidth / 2
              camera.right = cameraWidth / 2
              camera.top = cameraHeight / 2
              camera.bottom = -cameraHeight / 2
              camera.updateProjectionMatrix()
            } else if (name === 'side') {
              const roomAspect = this.roomWidth / this.ceilingHeight
              let cameraWidth
              let cameraHeight

              if (aspect > roomAspect) {
                cameraHeight = this.ceilingHeight
                cameraWidth = cameraHeight * aspect
              } else {
                cameraWidth = this.roomWidth
                cameraHeight = cameraWidth / aspect
              }

              const marginFactor = 1.5
              cameraWidth *= marginFactor
              cameraHeight *= marginFactor

              const viewCenterY = this.ceilingHeight * 0.1

              camera.left = -cameraWidth / 2
              camera.right = cameraWidth / 2
              camera.top = cameraHeight / 2
              camera.bottom = -cameraHeight / 2

              camera.position.set(0, viewCenterY, 500)
              camera.lookAt(0, viewCenterY, 0)

              camera.updateProjectionMatrix()
            }
          } else if (camera && camera.isPerspectiveCamera) {
            camera.aspect = width / height
            camera.updateProjectionMatrix()
          }
        }
      })

      setTimeout(() => {
        this.centerView('top')
        this.centerView('side')
      }, 100)
    })
  }

  async downloadPdf() {
    this.showNotification('Generazione PDF in corso...')

    try {
      const { jsPDF } = window.jspdf
      const pdf = new jsPDF('p', 'mm', 'a4')

      // Titolo
      pdf.setFontSize(16)
      pdf.text('CONFIGURAZIONE ZERO2 - ZAVA srl', 105, 15, { align: 'center' })

      // Data
      const now = new Date()
      const dateStr = now.toLocaleDateString('it-IT')
      const timeStr = now.toLocaleTimeString('it-IT', {
        hour: '2-digit',
        minute: '2-digit',
      })
      pdf.setFontSize(10)
      pdf.text(`Data: ${dateStr} - Ore: ${timeStr}`, 105, 22, {
        align: 'center',
      })

      let yPos = 30

      // Informazioni configurazione
      pdf.setFontSize(12)
      pdf.text('CONFIGURAZIONE', 20, yPos)
      yPos += 8

      pdf.setFontSize(10)
      const lampTypeSelect = document.getElementById('lampType')
      const lampTypeText =
        lampTypeSelect.options[lampTypeSelect.selectedIndex].text

      // Pulisci il testo del tipo paralumi
      const cleanLampType = this.cleanTextForPdf(lampTypeText)
      pdf.text(`Tipo Paralumi: ${cleanLampType}`, 20, yPos)
      yPos += 6

      pdf.text(`Numero Paralumi: ${this.lampCount}`, 20, yPos)
      yPos += 6

      // Dimensioni Bull individuali
      if (this.lampType === 'cylinder') {
        pdf.text('Dimensioni Paralumi Bull:', 20, yPos)
        yPos += 6

        for (let i = 0; i < this.lampCount; i += 1) {
          const height = this.getLampHeight(i)
          pdf.text(`  Paralume ${i + 1}: Ø2.5×${height} cm`, 25, yPos)
          yPos += 5
        }
      }

      pdf.text(`Larghezza Stanza: ${this.roomWidth} cm`, 20, yPos)
      yPos += 6
      pdf.text(`Profondita Stanza: ${this.roomDepth} cm`, 20, yPos)
      yPos += 6
      pdf.text(`Altezza Soffitto: ${this.ceilingHeight} cm`, 20, yPos)
      yPos += 20

      // Screenshot delle viste
      pdf.setFontSize(12)
      pdf.text('VISTE CONFIGURAZIONE', 105, yPos, { align: 'center' })
      yPos += 10

      // Prendi screenshot delle viste
      const views = ['3d', 'top', 'side']
      const viewNames = ['Vista 3D', 'Vista Pianta', 'Vista Laterale']

      for (let i = 0; i < views.length; i += 1) {
        const view = views[i]

        let pdfWidth
        let pdfHeight

        if (view === 'top') {
          pdfWidth = 150
        } else {
          pdfWidth = 160
        }

        this.renderers[view].render(this.scenes[view], this.cameras[view])

        const canvas = this.renderers[view].domElement

        try {
          const tempCanvas = document.createElement('canvas')
          const tempCtx = tempCanvas.getContext('2d')

          tempCanvas.width = canvas.width
          tempCanvas.height = canvas.height

          tempCtx.fillStyle = '#FFFFFF'
          tempCtx.fillRect(0, 0, tempCanvas.width, tempCanvas.height)
          tempCtx.drawImage(canvas, 0, 0)

          const imageData = tempCanvas.toDataURL('image/jpeg', 0.9)

          pdfHeight = (tempCanvas.height * pdfWidth) / tempCanvas.width

          if (yPos + pdfHeight > 260) {
            pdf.addPage()
            yPos = 20
          }

          const xPos = (210 - pdfWidth) / 2

          pdf.addImage(imageData, 'JPEG', xPos, yPos, pdfWidth, pdfHeight)

          pdf.setFontSize(9)
          pdf.text(viewNames[i], 105, yPos + pdfHeight + 5, { align: 'center' })

          yPos += pdfHeight + 15
        } catch (error) {
          console.error(`Errore nella cattura della vista ${view}:`, error)
          try {
            const imageData = canvas.toDataURL('image/jpeg', 0.9)

            pdfHeight = (canvas.height * pdfWidth) / canvas.width

            if (yPos + pdfHeight > 260) {
              pdf.addPage()
              yPos = 20
            }

            const xPos = (210 - pdfWidth) / 2

            pdf.addImage(imageData, 'JPEG', xPos, yPos, pdfWidth, pdfHeight)
            pdf.setFontSize(9)
            pdf.text(viewNames[i], 105, yPos + pdfHeight + 5, {
              align: 'center',
            })

            yPos += pdfHeight + 15
          } catch (err) {
            console.error(`Errore backup per vista ${view}:`, err)
          }
        }
      }

      // Lunghezza cavi
      if (yPos > 200) {
        pdf.addPage()
        yPos = 20
      }

      pdf.setFontSize(12)
      pdf.text('LUNGHEZZA CAVI', 20, yPos)
      yPos += 10

      pdf.setFontSize(10)
      const cableResults = document.getElementById('cableResults')
      const cableItems = cableResults.querySelectorAll('.result-item')

      const formatCableText = (text) => {
        let cleanText = text
          .replace(/[^\x00-\x7F]/g, '')
          .replace(/\s+/g, ' ')
          .trim()

        if (cleanText.includes('Rosone') && cleanText.includes('Supporto')) {
          return cleanText
        }

        const parts = cleanText.split('→')
        if (parts.length === 2) {
          const leftPart = parts[0].trim()
          const rightPart = parts[1].trim()

          const lengthMatch = rightPart.match(/(\d+\.?\d*)\s*cm/)

          if (lengthMatch) {
            const length = lengthMatch[1]
            const description = rightPart.replace(lengthMatch[0], '').trim()

            return {
              left: `${leftPart} → ${description || ''}`,
              right: `${length} cm`,
            }
          }
        }

        const midPoint = Math.floor(cleanText.length / 2)
        let splitPoint = midPoint
        for (let i = 0; i < 10; i += 1) {
          if (cleanText.charAt(midPoint + i) === ' ') {
            splitPoint = midPoint + i
            break
          }
          if (cleanText.charAt(midPoint - i) === ' ') {
            splitPoint = midPoint - i
            break
          }
        }

        return {
          left: cleanText.substring(0, splitPoint).trim(),
          right: cleanText.substring(splitPoint).trim(),
        }
      }

      cableItems.forEach((item) => {
        const rawText = item.textContent
        const formatted = formatCableText(rawText)

        if (formatted.left && formatted.right) {
          pdf.text(formatted.left, 20, yPos)
          pdf.text(formatted.right, 120, yPos, { align: 'right' })
        } else if (typeof formatted === 'string') {
          const midPoint = Math.floor(formatted.length / 2)
          pdf.text(formatted.substring(0, midPoint), 20, yPos)
          pdf.text(formatted.substring(midPoint), 120, yPos, { align: 'right' })
        }

        yPos += 6
      })

      pdf.setDrawColor(0)
      pdf.setLineWidth(0.1)
      pdf.line(20, yPos, 190, yPos)
      yPos += 4

      pdf.setFontSize(11)
      pdf.setFont(undefined, 'bold')
      const totalCableElement = document.getElementById('totalCable')
      const totalCableText = totalCableElement.textContent

      const cleanTotal = totalCableText
        .replace(/[^\x00-\x7F]/g, '')
        .replace(/\s+/g, ' ')
        .trim()

      pdf.text(`TOTALE: ${cleanTotal}`, 20, yPos)
      yPos += 10

      pdf.setFontSize(9)
      pdf.text('ZAVA srl - Sistema ZERO2', 105, 280, { align: 'center' })

      const fileName = `configurazione_zero2_${dateStr.replace(
        /\//g,
        '-'
      )}_${now.getHours()}${now.getMinutes()}.pdf`
      pdf.save(fileName)

      this.showNotification('PDF generato con successo!')
    } catch (error) {
      console.error('Errore nella generazione del PDF:', error)
      this.showNotification('Errore nella generazione del PDF')
    }
  }

  cleanTextForPdf(text) {
    if (!text) return ''

    return text
      .replace(/[^\x00-\x7F]/g, '')
      .replace(/\s+/g, ' ')
      .trim()
  }

  updateIndividualSizeControls() {
    const individualControls = document.getElementById('lampIndividualControls')
    const grid = document.getElementById('individualSizeGrid')

    grid.innerHTML = ''

    if (this.lampType === 'cylinder' && this.lampCount > 0) {
      individualControls.classList.add('visible')

      for (let i = 0; i < this.lampCount; i += 1) {
        const item = document.createElement('div')
        item.className = 'individual-size-item'

        const label = document.createElement('div')
        label.className = 'individual-size-label'
        label.textContent = `Paralume ${i + 1}`

        const select = document.createElement('select')
        select.dataset.index = i

        const sizes = ['20', '30', '40', '50', '75', '100']
        const currentSize = this.individualBullSizes[i] || 20

        sizes.forEach((size) => {
          const option = document.createElement('option')
          option.value = size
          option.textContent = `Ø2.5×${size} cm`
          if (parseFloat(currentSize) === parseFloat(size)) {
            option.selected = true
          }
          select.appendChild(option)
        })

        this._addListener(select, 'change', (event) => {
          const index = parseInt(event.target.dataset.index, 10)
          const size = event.target.value
          this.updateLampHeight(index, size)
        })

        item.appendChild(label)
        item.appendChild(select)
        grid.appendChild(item)
      }
    } else {
      individualControls.classList.remove('visible')
    }
  }

  updateOrthographicCameras() {
    if (this.cameras['top']) {
      const container = document.getElementById('sceneTop')
      const aspect = container.clientWidth / container.clientHeight
      const roomAspect = this.roomWidth / this.roomDepth

      let cameraWidth
      let cameraHeight

      if (aspect > roomAspect) {
        cameraHeight = this.roomDepth
        cameraWidth = cameraHeight * aspect
      } else {
        cameraWidth = this.roomWidth
        cameraHeight = cameraWidth / aspect
      }

      const marginFactor = 1.2
      cameraWidth *= marginFactor
      cameraHeight *= marginFactor

      this.cameras['top'].left = -cameraWidth / 2
      this.cameras['top'].right = cameraWidth / 2
      this.cameras['top'].top = cameraHeight / 2
      this.cameras['top'].bottom = -cameraHeight / 2
      this.cameras['top'].updateProjectionMatrix()
    }

    if (this.cameras['side']) {
      const container = document.getElementById('sceneSide')
      const aspect = container.clientWidth / container.clientHeight
      const roomAspect = this.roomWidth / this.ceilingHeight

      let cameraWidth
      let cameraHeight

      if (aspect > roomAspect) {
        cameraHeight = this.ceilingHeight
        cameraWidth = cameraHeight * aspect
      } else {
        cameraWidth = this.roomWidth
        cameraHeight = cameraWidth / aspect
      }

      const marginFactor = 1.5
      cameraWidth *= marginFactor
      cameraHeight *= marginFactor

      const viewCenterY = this.ceilingHeight * 0.4

      this.cameras['side'].left = -cameraWidth / 2
      this.cameras['side'].right = cameraWidth / 2
      this.cameras['side'].top = cameraHeight / 2
      this.cameras['side'].bottom = -cameraHeight / 2

      this.cameras['side'].position.set(0, viewCenterY, 500)
      this.cameras['side'].lookAt(0, viewCenterY, 0)

      this.cameras['side'].updateProjectionMatrix()
    }

    this.updateTopGrid()
  }

  handleObjectClick(viewName, event) {
    const rect = this.renderers[viewName].domElement.getBoundingClientRect()
    const mouse = new THREE.Vector2(
      ((event.clientX - rect.left) / rect.width) * 2 - 1,
      -((event.clientY - rect.top) / rect.height) * 2 + 1
    )

    const raycaster = new THREE.Raycaster()
    raycaster.setFromCamera(mouse, this.cameras[viewName])

    const scene = this.scenes[viewName]
    const selectableObjects = []

    scene.children.forEach((child) => {
      if (
        child.userData.type === 'lamp' ||
        child.userData.type === 'bracket' ||
        child.userData.type === 'rosette' ||
        child.userData.type === 'finalBracket'
      ) {
        selectableObjects.push(child)
      }
    })

    const intersects = raycaster.intersectObjects(selectableObjects)

    if (intersects.length > 0) {
      const object = intersects[0].object
      const type = object.userData.type
      const index = object.userData.index

      let selected3dObject = null

      if (type === 'lamp') {
        selected3dObject = this.lamps3d[index]
      } else if (type === 'bracket') {
        selected3dObject = this.brackets3d[index]
      } else if (type === 'rosette') {
        selected3dObject = this.rosette3d
      } else if (type === 'finalBracket') {
        selected3dObject = this.finalBracket3d
      }

      if (selected3dObject) {
        this.selectObject(selected3dObject, viewName)
        event.stopPropagation()
      }
    }
  }

  selectObject(object, viewName) {
    this.deselectObject()

    this.selectedObject = object
    this.selectedObjectType = object.userData.type
    this.selectedObjectIndex = object.userData.index

    object.userData.originalColor = object.material.color.getHex()
    object.material.color.setHex(0xff0000)

    Object.keys(this.transformControls).forEach((view) => {
      this.transformControls[view].attach(object)

      if (view === '3d') {
        if (this.selectedObjectType === 'lamp') {
          this.transformControls[view].showX = false
          this.transformControls[view].showY = true
          this.transformControls[view].showZ = false
        } else {
          this.transformControls[view].showX = true
          this.transformControls[view].showY = false
          this.transformControls[view].showZ = true
        }
      } else if (view === 'top') {
        if (this.selectedObjectType === 'lamp') {
          this.transformControls[view].showX = false
          this.transformControls[view].showY = false
          this.transformControls[view].showZ = false
        } else {
          this.transformControls[view].showX = true
          this.transformControls[view].showY = false
          this.transformControls[view].showZ = true
        }
      } else if (view === 'side') {
        if (this.selectedObjectType === 'lamp') {
          this.transformControls[view].showX = false
          this.transformControls[view].showY = true
          this.transformControls[view].showZ = false
        } else {
          this.transformControls[view].showX = true
          this.transformControls[view].showY = false
          this.transformControls[view].showZ = false
        }
      }
    })

    this.updateInfo()
  }

  deselectObject() {
    if (
      this.selectedObject &&
      this.selectedObject.userData.originalColor !== undefined
    ) {
      this.selectedObject.material.color.setHex(
        this.selectedObject.userData.originalColor
      )
    }

    Object.keys(this.transformControls).forEach((view) => {
      this.transformControls[view].detach()
    })

    this.selectedObject = null
    this.selectedObjectType = null
    this.selectedObjectIndex = null

    this.updateInfo()
  }

  setTransformMode(mode) {
    this.currentMode = mode

    Object.keys(this.transformControls).forEach((view) => {
      this.transformControls[view].setMode('translate')
    })
  }

  applyTransformConstraints() {
    if (!this.selectedObject) return

    const pos = this.selectedObject.position

    pos.x = Math.max(
      -this.roomWidth / 2 + 20,
      Math.min(pos.x, this.roomWidth / 2 - 20)
    )
    pos.z = Math.max(
      -this.roomDepth / 2 + 20,
      Math.min(pos.z, this.roomDepth / 2 - 20)
    )

    if (this.selectedObjectType === 'lamp') {
      const height = this.getLampHeight(this.selectedObjectIndex)
      pos.y = Math.max(height / 2 + 5, Math.min(pos.y, this.ceilingHeight - 10))

      this.updateLampPositions()
    } else if (
      this.selectedObjectType === 'bracket' ||
      this.selectedObjectType === 'finalBracket'
    ) {
      pos.y = this.ceilingHeight - 1.5
    } else if (this.selectedObjectType === 'rosette') {
      pos.y = this.ceilingHeight - 1.5
    }

    this.selectedObject.position.copy(pos)
  }

  updateCorrespondingObjects() {
    if (!this.selectedObject) return

    const index = this.selectedObjectIndex
    const type = this.selectedObjectType
    const position = this.selectedObject.position.clone()

    if (type === 'lamp') {
      if (this.lampsSide[index]) {
        this.lampsSide[index].position.set(position.x, position.y, 0)
      }
      if (this.lampsTop[index]) {
        this.lampsTop[index].position.set(position.x, 0.2, position.z)
      }
    } else if (type === 'bracket') {
      if (this.bracketsSide[index]) {
        this.bracketsSide[index].position.set(position.x, position.y, 0)
      }
      if (this.bracketsTop[index]) {
        this.bracketsTop[index].position.set(position.x, 0.2, position.z)
      }
    } else if (type === 'finalBracket') {
      if (this.finalBracketSide) {
        this.finalBracketSide.position.set(position.x, position.y, 0)
      }
      if (this.finalBracketTop) {
        this.finalBracketTop.position.set(position.x, 0.2, position.z)
      }
    } else if (type === 'rosette') {
      if (this.rosetteSide) {
        this.rosetteSide.position.set(position.x, position.y, 0)
      }
      if (this.rosetteTop) {
        this.rosetteTop.position.set(position.x, 0.3, position.z)
      }
    }
  }

  updateInfo() {
    if (!this.selectedObject) {
      document.getElementById('info-title').textContent =
        'Nessun elemento selezionato'
      document.getElementById('info-coords').textContent =
        'X: 0.0 | Y: 0.0 | Z: 0.0'
      return
    }

    const pos = this.selectedObject.position
    const type = this.selectedObjectType
    const index = this.selectedObjectIndex

    const title =
      type === 'lamp'
        ? `Paralume ${index + 1}`
        : type === 'bracket'
        ? `Supporto ${index + 1}`
        : type === 'finalBracket'
        ? 'Supporto Finale'
        : 'Rosone'

    document.getElementById('info-title').textContent = title
    document.getElementById('info-coords').textContent = `X: ${pos.x.toFixed(
      1
    )} | Y: ${pos.y.toFixed(1)} | Z: ${pos.z.toFixed(1)}`
  }

  centerView(viewName) {
    const camera = this.cameras[viewName]
    const controls = this.controls[viewName]

    if (viewName === 'top') {
      const container = document.getElementById('sceneTop')
      const aspect = container.clientWidth / container.clientHeight
      const roomAspect = this.roomWidth / this.roomDepth

      let cameraWidth
      let cameraHeight

      if (aspect > roomAspect) {
        cameraHeight = this.roomDepth
        cameraWidth = cameraHeight * aspect
      } else {
        cameraWidth = this.roomWidth
        cameraHeight = cameraWidth / aspect
      }

      const marginFactor = 1.2
      cameraWidth *= marginFactor
      cameraHeight *= marginFactor

      camera.left = -cameraWidth / 2
      camera.right = cameraWidth / 2
      camera.top = cameraHeight / 2
      camera.bottom = -cameraHeight / 2
      camera.zoom = 1

      camera.position.set(0, 500, 0)
      camera.lookAt(0, 0, 0)
      camera.up.set(0, 0, 1)
    } else if (viewName === 'side') {
      const container = document.getElementById('sceneSide')
      const aspect = container.clientWidth / container.clientHeight
      const roomAspect = this.roomWidth / this.ceilingHeight

      let cameraWidth
      let cameraHeight

      if (aspect > roomAspect) {
        cameraHeight = this.ceilingHeight
        cameraWidth = cameraHeight * aspect
      } else {
        cameraWidth = this.roomWidth
        cameraHeight = cameraWidth / aspect
      }

      const marginFactor = 1.5
      cameraWidth *= marginFactor
      cameraHeight *= marginFactor

      camera.left = -cameraWidth / 2
      camera.right = cameraWidth / 2
      camera.top = cameraHeight / 2
      camera.bottom = -cameraHeight / 2
      camera.zoom = 1

      const viewCenterY = this.ceilingHeight * 1.5

      camera.position.set(0, viewCenterY, 500)
      camera.lookAt(0, viewCenterY, 0)
      camera.up.set(0, 1, 0)
    }

    if (camera.isOrthographicCamera) {
      camera.updateProjectionMatrix()
    }
    controls.update()
  }

  zoomView(viewName, factor) {
    const camera = this.cameras[viewName]
    if (camera.isOrthographicCamera) {
      camera.zoom *= factor
      camera.zoom = Math.max(0.1, Math.min(10, camera.zoom))
      camera.updateProjectionMatrix()
      this.controls[viewName].update()
    }
  }

  calculateCables() {
    if (this.lampCount === 0 || !this.rosette3d) {
      this.showResults([], 0)
      return
    }

    let totalLength = 0
    const segments = []

    if (this.brackets3d[0]) {
      const startPoint = new THREE.Vector3(
        this.rosette3d.position.x,
        this.rosette3d.position.y - 1.5,
        this.rosette3d.position.z
      )

      const toBracketPoint = new THREE.Vector3(
        this.brackets3d[0].position.x,
        this.brackets3d[0].position.y + 1.5,
        this.brackets3d[0].position.z
      )

      const toBracketLength = startPoint.distanceTo(toBracketPoint)
      segments.push({
        name: 'Rosone → Supporto 1',
        length: toBracketLength,
      })
      totalLength += toBracketLength

      let currentPoint = toBracketPoint.clone()

      for (let i = 0; i < this.lampCount; i += 1) {
        const lamp = this.lamps3d[i]
        if (!lamp) continue

        const height = this.getLampHeight(i)
        const toLampPoint = new THREE.Vector3(
          lamp.position.x,
          lamp.position.y + height / 2,
          lamp.position.z
        )
        const toLampLength = currentPoint.distanceTo(toLampPoint)

        segments.push({
          name: `Supporto ${i === 0 ? 1 : i + 1} → Paralume ${i + 1}`,
          length: toLampLength,
        })
        totalLength += toLampLength

        currentPoint = toLampPoint.clone()

        let nextBracketIndex
        if (i === 0) {
          nextBracketIndex = 1
        } else {
          nextBracketIndex = i + 1
        }

        let nextBracketPoint

        if (nextBracketIndex < this.lampCount) {
          const nextBracket = this.brackets3d[nextBracketIndex]
          if (!nextBracket) continue

          nextBracketPoint = new THREE.Vector3(
            nextBracket.position.x,
            nextBracket.position.y + 1.5,
            nextBracket.position.z
          )
        } else if (this.finalBracket3d) {
          nextBracketPoint = new THREE.Vector3(
            this.finalBracket3d.position.x,
            this.finalBracket3d.position.y + 1.5,
            this.finalBracket3d.position.z
          )
        } else {
          continue
        }

        const toNextBracketLength = currentPoint.distanceTo(nextBracketPoint)
        segments.push({
          name: `Paralume ${i + 1} → Supporto ${nextBracketIndex + 1}`,
          length: toNextBracketLength,
        })
        totalLength += toNextBracketLength

        currentPoint = nextBracketPoint.clone()
      }
    }

    this.showResults(segments, totalLength)
  }

  showResults(segments, totalLength) {
    const container = document.getElementById('cableResults')
    container.innerHTML = ''

    segments.forEach((seg) => {
      const div = document.createElement('div')
      div.className = 'result-item'
      div.innerHTML = `
        <span>${seg.name}</span>
        <span>${seg.length.toFixed(1)} cm</span>
      `
      container.appendChild(div)
    })

    document.getElementById('totalCable').textContent = `${totalLength.toFixed(
      1
    )} cm`
  }

  animate() {
    if (this._isDestroyed) return
    this._animationId = requestAnimationFrame(() => this.animate())

    Object.keys(this.controls).forEach((name) => {
      this.controls[name].update()
    })

    this.updateHeightLabels()

    Object.keys(this.renderers).forEach((name) => {
      this.renderers[name].render(this.scenes[name], this.cameras[name])
    })
  }
}

let configuratorInstance = null

onMounted(async () => {
  await nextTick()
  if (typeof window === 'undefined') return

  const scripts = [
    'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js',
    'https://cdn.jsdelivr.net/npm/three@0.128.0/examples/js/controls/OrbitControls.min.js',
    'https://cdn.jsdelivr.net/npm/three@0.128.0/examples/js/controls/TransformControls.min.js',
    'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js',
    'https://html2canvas.hertzen.com/dist/html2canvas.min.js',
  ]

  try {
    for (const src of scripts) {
      await loadScript(src)
    }

    configuratorInstance = new LampConfigurator3D()
  } catch (error) {
    console.error(
      'Errore nel caricamento degli script del configuratore:',
      error
    )
  }
})

onBeforeUnmount(() => {
  if (configuratorInstance?.destroy) {
    configuratorInstance.destroy()
  }
  configuratorInstance = null
})
</script>
